import {
  GET_PLANS_SUCCESS,
  SELECT_PLAN,
  CLEAR_PLANS,
  CLEAR_SELECTED_PLAN,
  DISABLE_FREE_PROMO,
  GET_PLANS_REQUEST,
  DISABLE_DEFAULT_PROMO,
} from '../Types';

const initialState = {
  isFetchingPlans: false,
  isPlanSelected: false,
  allPlans: [],
  getPlansSuccess: false,
  selectedPlan: null,
  selectedPlanPrice: 0,
  selectedPlanId: null,
  selectPlanActionComplete: false,
  showFreeTrialPromo: true,
  showDefaultPromo: true,
};

// reducer
export const plans = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_PLAN:
      return {
        ...state,
        ...action.payload,
        isPlanSelected: true,
        selectPlanActionComplete: true,
      };
    case GET_PLANS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        getPlansSuccess: true,
        isFetchingPlans: false,
      };
    case GET_PLANS_REQUEST:
      return {
        ...state,
        ...action.payload,
        isFetchingPlans: true,
      };
    case DISABLE_FREE_PROMO:
      return { ...state, showFreeTrialPromo: false };
    case DISABLE_DEFAULT_PROMO:
      return { ...state, showDefaultPromo: false };
    case CLEAR_SELECTED_PLAN:
      return {
        ...state,
        isPlanSelected: initialState.selectedPlan,
        selectedPlan: initialState.selectedPlan,
        selectedPlanPrice: initialState.selectedPlanPrice,
        selectedPlanId: initialState.selectedPlanId,
        selectPlanActionComplete: true,
      };
    case CLEAR_PLANS:
      return { ...state, ...initialState };
    default:
      return state;
  }
};
